import { postRequest, getRequest, setDefaultConfig } from 'cupshe-axios'
let vuex = {}
if (localStorage.getItem('vuex')) {
  vuex = JSON.parse(localStorage.getItem('vuex'))
}
// 全局设置axios
setDefaultConfig({
  timeout: 60000,
  isJumpLogin: true,
  headers: {
    tokenSign: 2,
    userName: encodeURIComponent(vuex?.user?.userInfo?.userName),
    userId: localStorage.getItem('userId'),
    user_id: localStorage.getItem('userId'),
    token: localStorage.getItem('token'),
    accountId: localStorage.getItem('accountId'),
    'source-from-supplier': undefined
  }
})

export const get = getRequest
export const post = postRequest
